module.exports = __webpack_public_path__ + "img/Backend.32e35157.svg";